export default __webpack_public_path__ + "static/media/logo-dark.568ab480.svg";